import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import { connect } from 'react-redux'
import {loadChannels, categoryChanged} from './actions/channelList';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import {setChannel} from './actions/video';
import Cast from '@material-ui/icons/Cast';
import IconButton from '@material-ui/core/IconButton';
import { connectCast } from './actions/cast';

class ChannelList extends Component{
  adds;
  constructor(props){
    super(props);
    this.onTabCahnge = this.onTabCahnge.bind(this);
    this.setChannel = this.setChannel.bind(this);
    this.adds = [this.renderAdd(),this.renderAdd()];
  }

  renderAdd(){
    return(
       <div>
         <ListItem className="add_list_item">
       </ListItem>
       <Divider/>
       </div>
    )
  }

  componentWillMount() {
    this.props.dispatch(loadChannels());
  }
  componentDidMount(){
    window.addEventListener('resize',()=>{
      this.forceUpdate();      
    },false)
  }
  componentWillReceiveProps(nextProps){
      if(Object.keys(this.props.channels).length === 0){
        this.onTabCahnge(null,0);
      }
  }
  onTabCahnge(event,index){
     this.props.dispatch(categoryChanged({index, channels:this.props.allChannels}));
  }

  setChannel(channel){
    this.props.dispatch(setChannel(channel));
  }
  playCast(channel){
      this.props.dispatch(connectCast(channel))
  }
  renderAppBar(channels){
    if(window.innerWidth > 768) return (<div></div>);
    return (
      <AppBar position="static" color="default">
      <Tabs
                  onChange =  {this.onTabCahnge}
                  value='0'
                  indicatorColor="primary"
                  textColor="primary"
                  scrollable
                  scrollButtons="auto"
      >
          {
            this.props.categories.map((item,index)=>{
              return (<Tab value={index.toString()} key={index} label={item}/>)
            })
          }
      </Tabs>
      </AppBar>
    )
  }
  renderChannelList(channels){
    if(window.innerWidth > 768){
      return this.renderDesktopList(channels);
    }else{
      return this.renderMobileList(channels);
    }
  }
  renderMobileList(channels){
    return(
      <List className="channel-list">
      {this.adds[0]}
      {
        
        Object.keys(this.props.channels).map((item, index)=>{
          let channel = this.props.channels[item];
          
          return (
            <div key={item}>
            <ListItem button onClick={this.setChannel.bind(this,channel)}>
              <Avatar className="avatar" alt={channel.name} src={channel.logo_url} />
              <ListItemText primary={channel.name} />
              <ListItemSecondaryAction>
                <IconButton onClick={this.playCast.bind(this,channel)}><Cast/></IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </div>
          )
        })
      }
      {this.adds[1]}
    </List>
    );
  }
  renderDesktopList(channels){
    return(
      <List className="channel-list">
        {this.adds[0]}
        {
          Object.keys(this.props.allChannels).map((item,index)=>{
            return Object.keys(this.props.allChannels[item]).map((ch,i)=>{
                let channel = this.props.allChannels[item][ch];
                return(
                  <div key={channel.name}>
                  <ListItem button onClick={this.setChannel.bind(this,channel)}>
                    <Avatar className="avatar" alt={channel.name} src={channel.logo_url} />
                    <ListItemText primary={channel.name} />
                    <ListItemSecondaryAction>
                      <IconButton onClick={this.playCast.bind(this,channel)}><Cast/></IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                </div>
                )
            });
          })
        }
        {this.adds[1]}
      </List>
    )
  }
  render(){  
    let channels = this.props.channels || null;
    if(!channels) return;
    return (
      <div className="channel-list-wrapper">
        { this.renderAppBar(channels) }
        { this.renderChannelList(channels) }
      </div>
    )
  }
}

const mapStateToProps = (state,ownProps) =>{
  return {
    channels: state.channelList,
    categories: state.channelCategories,
    allChannels: state.allChannels
  }
}

ChannelList = connect(mapStateToProps)(ChannelList);
export default ChannelList;



// WEBPACK FOOTER //
// ./src/channelList.js